import { inject, InjectionKey } from 'vue';
import { AbsenceApiService } from './absenceApiService';

export const ABSENCE_API_KEY: InjectionKey<AbsenceApiService> = Symbol('AbsenceApiService');

export function useAbsenceApi(): AbsenceApiService {
	const service = inject<AbsenceApiService>(ABSENCE_API_KEY);
	if (!service) throw new Error('AbsenceApiService not provided');
	return service;
}
